import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavItem } from '@app/interfaces/nav-item';
import { EmptyBlockComponent } from '@app/layout/empty-block/empty-block.component';
import { NavComponent } from '@app/layout/nav/nav.component';
import { AuthSelectors, CartSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { filter, map, Observable } from 'rxjs';
import { CartFormComponent } from './cart-form/cart-form.component';

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, AsyncPipe, CartFormComponent, EmptyBlockComponent],
})
export class CartPage implements OnInit {
  constructor(private store: Store) {}

  protected imageDetailsIds$: Observable<number[]> = this.store.select(
    CartSelectors.imageDetailsIds,
  );

  protected isAuthenticated$: Observable<boolean | undefined> =
    this.store.select(AuthSelectors.isAuthenticated);

  protected hasItemsInCart$!: Observable<boolean>;

  protected navItems: NavItem[] = [{ label: 'Cart' }];

  ngOnInit(): void {
    this.hasItemsInCart$ = this.imageDetailsIds$.pipe(
      filter((imageDetailsIds: number[]) => {
        return imageDetailsIds !== undefined;
      }),
      map((imageDetailsIds: number[]) => {
        return imageDetailsIds.length > 0;
      }),
    );
  }
}
